// extracted by mini-css-extract-plugin
export default {"date-time":"styles_date-time__yUi9I"};